import { MaePaiUseCase } from '@/features/proposta/entities/Comprador/use-case/mae-pai-use-case'
import type { TCompradoresCadastrados } from '@/features/proposta/interfaces/proposta.type'
import type {
  TClientePessoaFisicaPropostaSchema,
  TClientePessoaJuridicaPropostaSchema,
} from '@/features/proposta/schemas'
import type {
  CompradorPessoaFisicaStepSchemaInput,
  CompradorVinculoStepSchemaInput,
} from '@/features/proposta/schemas/compradores/comprador-pf.schema'

export const transformarPJParaVinculoRepresentanteLegal = (
  pjSelecionada: TClientePessoaJuridicaPropostaSchema,
  nacionalidades?: Array<{ id: string }>,
): CompradorVinculoStepSchemaInput => {
  return {
    emailsJaVinculados: {},
    compradorVinculadoIds: [pjSelecionada.id],
    tipo: 'Representante',
    tipoDoCliente: 'Contato',
    imagem: null,
    dados: {
      buscouCpf: false,
      cpf: '',
      nome: '',
      nacionalidadeId: nacionalidades?.[0]?.id ?? '',
      profissaoId: '',
      email: '',
      id: '',
      maiorDe18Anos: 'sim',
    },
    contato: {
      email: '',
      telefone: {
        origem: 'Brasil',
        numero: '',
        principal: true,
      },
    },
    estadoCivil: {
      status: undefined,
      tipoAssinatura: null,
      regimeCasamento: null,
      uniaoEstavel: null,
    },
    mode: 'create',
  }
}

export const transformarCompradorPFListagemParaFormulario = (
  value: TClientePessoaFisicaPropostaSchema,
  compradores: TCompradoresCadastrados,
  clientes: TClientePessoaFisicaPropostaSchema[],
  mode: 'create' | 'edit',
  emailsJaVinculados: Record<string, string>,
  fluxoIndependente?: 'MaePai' | 'Conjuge',
): CompradorPessoaFisicaStepSchemaInput => {
  const cliente = compradores.find((c) => c.id === value.id)

  const conjugeId = cliente?.vinculos.find((v) => v.tipo === 'Conjuge')?.id
  const conjuge = conjugeId ? clientes.find((c) => c.id === conjugeId) : null
  const maePai = cliente?.vinculos.find((v) => v.tipo === 'MaePai')

  const maePaiParaStep = (): CompradorPessoaFisicaStepSchemaInput['maePai'] => {
    if (fluxoIndependente === 'MaePai' && maePai) {
      if (mode === 'create') return MaePaiUseCase.iniciarDefaultValues(emailsJaVinculados)
      const dadosComprador = clientes.find((c) => c.id === maePai.id)!
      return {
        emailsJaVinculados,
        dados: {
          id: dadosComprador.id,
          cpf: dadosComprador.cpf,
          nome: dadosComprador.nome,
          nacionalidadeId: dadosComprador.nacionalidadeId,
          profissaoId: dadosComprador.profissaoId,
          maiorDe18Anos: 'sim',
        },
        contato: {
          email: dadosComprador.email,
          telefone: {
            numero: dadosComprador.telefone.numero,
            origem: dadosComprador.telefone.origem,
            principal: dadosComprador.telefone.principal,
          },
        },
        imagem: dadosComprador.imagem,
        tipo: 'MaePai',
        estadoCivil: {
          status: dadosComprador.estadoCivil,
          regimeCasamento: dadosComprador.regimeCasamento,
          uniaoEstavel: dadosComprador.possuiUniaoEstavel ? 'sim' : 'nao',
        },
      }
    }
    return null
  }
  return {
    emailsJaVinculados,
    tipoDoCliente: 'Contato',
    tipo: 'PessoaFisica',
    dados: {
      id: value.id,
      cpf: value.cpf,
      nome: value.nome,
      nacionalidadeId: value.nacionalidadeId,
      profissaoId: value.profissaoId,
      maiorDe18Anos: value.maiorDe18Anos ? 'sim' : 'nao',
      email: value.maiorDe18Anos ? null : value.email,
    },
    mode: mode,
    maePai: maePaiParaStep(),
    conjuge: conjuge
      ? {
          imagem: conjuge.imagem,
          dados: {
            id: conjuge.id,
            cpf: conjuge.cpf,
            nome: conjuge.nome,
            nacionalidadeId: conjuge.nacionalidadeId,
            profissaoId: conjuge.profissaoId,
            maiorDe18Anos: 'sim',
          },
          contato: {
            email: conjuge.email,
            telefone: {
              numero: conjuge.telefone.numero,
              origem: conjuge.telefone.origem,
              principal: conjuge.telefone.principal,
            },
          },
        }
      : null,
  }
}
